import React from "react";
import HeroSection from "../../components/public/HeroSection";
import BrandsSection from "../../components/public/BrandsSection";
import ClimatisationSection from "../../components/public/ClimatisationSection";
import ServicesSection from "../../components/public/ServicesSection";
import Differenciation from "../../components/public/Differenciation";
import RealisationsSection from "../../components/public/RealisationsSection";
import TestimonialsSection from "../../components/public/TestimonialsSection";
import FAQSection from "../../components/public/FAQSection";
import ZonesSection from "../../components/public/ZonesSection";
import CTASection from "../../components/public/CTASection";
import { useSettings } from "../../lib/useSettings";

export default function HomePage() {
  const { settings: s } = useSettings();
  return (
    <>
      <title>{s ? `${s.company_name} — ${s.tagline}` : "Kloub'Air Plomberie"}</title>
      <meta name="description" content={s?.hero_subtitle || "Installation climatisation & plomberie à Grans et Bouches-du-Rhône."}/>
      <HeroSection/>
      <BrandsSection/>
      <ClimatisationSection/>
      <ServicesSection onlyFeatured={true} title="Tous nos services" subtitle="Climatisation · Plomberie · Dépannage"/>
      <Differenciation/>
      <RealisationsSection/>
      <TestimonialsSection/>
      <FAQSection/>
      <ZonesSection/>
      <CTASection/>
    </>
  );
}
